import type React from "react";

// Route mapping keys - ordered by priority
// Extracted to avoid circular dependency: routes/* import this, mapping imports routes
export enum ERouteMappingKeys {
  CLOUD_GATEWAYS = "CLOUD_GATEWAYS",
  SWITCHING = "SWITCHING",
  WIFI = "WIFI",
  CAMERA_SECURITY = "CAMERA_SECURITY",
  DOOR_ACCESS = "DOOR_ACCESS",
  ACCESSORY_TECH = "ACCESSORY_TECH",
  WHATS_NEW = "WHATS_NEW",
  MANAGED_VOIP = "MANAGED_VOIP",
  SPECIAL_DEVICES = "SPECIAL_DEVICES",
  HOW_IT_WORKS = "HOW_IT_WORKS",
  PREMIUM_IOT = "PREMIUM_IOT",
  POWER_TECH = "POWER_TECH",
  IDENTITY = "IDENTITY",
  MOBILE_ROUTING = "MOBILE_ROUTING",
  NETWORK_STORAGE = "NETWORK_STORAGE",
  CLOUD_KEYS_GATEWAYS = "CLOUD_KEYS_GATEWAYS",
  DOWNLOAD = "DOWNLOAD",
  PARTNER_HUB = "PARTNER_HUB",
  UI_CARE = "UI_CARE",
  ULTRA = "ULTRA",
  VIDEO_RECORDERS = "VIDEO_RECORDERS",
  PROFESSIONAL_INTEGRATORS = "PROFESSIONAL_INTEGRATORS",
  SITE_SUPPORT = "SITE_SUPPORT",
  TRUST_CENTER = "TRUST_CENTER",
}

export interface RouteMapping {
  id: string;
  path: string;
  components: Record<string, React.LazyExoticComponent<React.ComponentType>>;
}
